export const CALENDAR_STORAGE_KEY = 'calendar-events-view'
export const calendarEventsApi = useExtendedApi(
  'calendar-events',
  ['category', 'calendarEventStatus'],
  CALENDAR_STORAGE_KEY
)
export const apiTimeTracking = useExtendedApi(
  'time-tracking',
  ['task', 'project'],
  CALENDAR_STORAGE_KEY
)
export const calendarCategoryApi = useExtendedApi('calendar-categories')

export const CALENDAR_TIMELINE_STORAGE_KEY = 'calendar-timeline-view'

export const CALENDAR_TIMELINE_SKILLS_STORAGE_KEY = 'calendar-timeline-skills'

export const CALENDAR_TIMELINE_PINNED_STORAGE_KEY = 'calendar-timeline-pinned'
export const apiTimeline = useExtendedApi(
  'resource-plan-items',
  ['project,users.user'],
  CALENDAR_TIMELINE_STORAGE_KEY
)

export const apiTaskTimeline = useExtendedApi('tasks', [], CALENDAR_TIMELINE_STORAGE_KEY)

export enum CalenderViewEnum {
  dayGridMonth = 'dayGridMonth',
  timeGridWeek = 'timeGridWeek',
  timeGridDay = 'timeGridDay',
  agendaView = 'agendaView'
}
export enum TimelineViewEnum {
  timelineOneDay = 'timelineOneDay',
  timelineTwoDays = 'timelineTwoDays',
  resourceTimelineWeek = 'resourceTimelineWeek',
  timelineTwoWeeks = 'timelineTwoWeeks',
  timelineFourWeeks = 'timelineFourWeeks',
  timelineEightWeeks = 'timelineEightWeeks',
  timelineSixMonths = 'timelineSixMonths',
  timelineOneYear = 'timelineOneYear'
}

export enum CALENDAR_TYPES {
  EVENT = 'event',
  TASK = 'task',
  CALENDAR = 'calendar'
}
export const EVENT_COLOR = '#74508f'
export const TASK_COLOR = '#74aaaa'
export const CALENDAR_COLOR = '#2f86fe'

export function dbDateTime(value: Date | null): string {
  if (!value) return ''
  const formattedDate = new Date(value.getTime() - value.getTimezoneOffset() * 60000).toISOString()
  const date = formattedDate.split('T')[0]

  const time = value ? new Date(value).toLocaleTimeString() : new Date().toLocaleTimeString()

  return `${date} ${time}`
}

export const useCalendarStore = defineStore('calendar', {
  state: () => ({
    loading: false,
    storeEvent: [],
    storeTimeTracking: [] as TimetrackEvent[],
    resourceUsers: [] as TimelineCalendarResource[]
  }),
  actions: {
    fetchResources(
      id = '',
      roleId = '',
      skillFilter = '',
      latitude = null,
      longitude = null
    ): Promise<TimelineCalendarResource[]> {
      return new Promise((resolve) => {
        const filter = id ? `&filter[id]=${id}` : ''
        const roleFilter = roleId ? `&filter[role_id]=${roleId}` : ''
        const teamFilter = ``
        const skillFilterParam = skillFilter ? `&filter[skill]=${skillFilter}` : ''

        const locationParams =
          latitude !== null && longitude !== null
            ? `&latitude=${latitude}&longitude=${longitude}&sort=distance`
            : '&sort=name'

        useApi(
          `users?filter[resource-plan]=only&filter[inactive]=without${filter}${roleFilter}${teamFilter}${skillFilterParam}${locationParams}&per_page=${Number.MAX_SAFE_INTEGER}`,
          'GET'
        )
          .then((usersResponse) => {
            const users = usersResponse?.data || []
            this.resourceUsers = users
            resolve(users)
          })
          .catch()
      })
    }
  }
})
